import React from "react";
import WarningColumn from "../ui/CenteredWarning/CenteredWarning";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../store";
import parkingProductsActions from "../store/actions/parkingProducts.actions";
import useAppContext from "../context/hooks/useAppContext";

export function useBlockVehicleConcurrentUpload() {
  const dispatch = useAppDispatch();
  const { appState: { user: { seasonTicketOwnerCrmId }}} = useAppContext();
  const blocked = useAppSelector((state) => !state.parkingProducts.isBulkVehicleAssignmentsCompleted);
  const fetch = () => {
    dispatch(parkingProductsActions.getBulkVehicleAssignmentsStatus(seasonTicketOwnerCrmId!));
  }

  return {
    blocked,
    fetch
  };
}

function VehicleConcurrentUploadWarning() {
  const { t } = useTranslation();

  return (
    <div className="bulkimport-inprogress-warning">
      <WarningColumn
        title={t("delegeeForm:bulkImportInProgressWarningTitle")}
        details={t("delegeeForm:bulkImportInProgressWarningDescription")}
        orangeWarning={true}
      />
    </div>
  );
}

export default VehicleConcurrentUploadWarning;
